module.exports = __webpack_public_path__ + "assets/campaign-edit.6dffcd73.svg";